<template>
  <component
    :is="unitPanelContentComponent"
    :project-element="unit"
    :access-links-enabled="accessLinksEnabled"
  ></component>
</template>

<script>
import { UnitTypes } from '@/constants/units'
import Unit from '@/classes/ProjectStructure/Unit/Unit'
import UnitPanelLargeContent from '@/components/PanelContent/panels/UnitPanel/UnitPanelLargeContent'
import UnitPanelLargeContentAmenities from '@/components/PanelContent/panels/UnitPanel/UnitPanelLargeContentAmenities'

export default {
  name: 'UnitPanelLargeContentFactory',
  components: {
    UnitPanelLargeContent,
  },
  props: {
    projectElement: {
      type: Unit,
      default: () => undefined,
    },
    accessLinksEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    unit() {
      return this.projectElement
    },
    unitPanelContentComponent() {
      const panelContentsByUnitType = {
        [UnitTypes.AMENITIES]: UnitPanelLargeContentAmenities,
        [UnitTypes.APARTMENT]: UnitPanelLargeContent,
        [UnitTypes.OFFICE]: UnitPanelLargeContent,
        [UnitTypes.SHOP]: UnitPanelLargeContent,
        [UnitTypes.HOUSE]: UnitPanelLargeContent,
      }
      return panelContentsByUnitType[this.unit.type]
    },
  },
}
</script>
